"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useWatchCookie = void 0;
const react_1 = require("react");
const useWatchCookie = (cookieName, callback, fallbackEvent) => {
    (0, react_1.useEffect)(() => {
        if (!window) {
            return;
        }
        if ('cookieStore' in window) {
            window.cookieStore.addEventListener('change', (event) => {
                if (!event || !event.changed) {
                    return;
                }
                const changedCookieEvent = event.changed.find(cookie => cookie.name === cookieName);
                changedCookieEvent && (callback === null || callback === void 0 ? void 0 : callback(event));
            });
        }
        else {
            window.addEventListener(fallbackEvent, callback);
        }
        return () => {
            if ('cookieStore' in window) {
                window.cookieStore.removeEventListener('change', callback);
            }
            else {
                window.removeEventListener(fallbackEvent, callback);
            }
        };
    }, []);
};
exports.useWatchCookie = useWatchCookie;
